import { m } from '@aimfora/i18n'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { AccountsPage } from '~/components/admin/accounts-page'
import { PageHeader } from '~/components/app-shell'

export const Route = createFileRoute('/_authed/_admin/admin/accounts')({
  validateSearch: z.object({
    q: z.string().max(100).catch('').default(''),
    status: z
      .enum(['all', 'no_account', 'unverified', 'active', 'banned'])
      .catch('all')
      .default('all'),
    page: z.number().int().min(0).catch(0).default(0),
    mq: z.string().max(100).catch('').default(''),
    mpage: z.number().int().min(0).catch(0).default(0),
  }),
  head: () => ({ meta: [{ title: `${m.admin_nav_accounts()} - ${m.app_name()}` }] }),
  component: AccountsRoute,
})

function AccountsRoute() {
  const search = Route.useSearch()
  return (
    <>
      <PageHeader title={m.admin_nav_accounts()} description={m.admin_accounts_description()} />
      <AccountsPage search={search} />
    </>
  )
}
